/**
 * Services Section Component
 */
function ServicesSection() {
  const services = [
    {
      icon: 'fas fa-solid fa-route',
      title: 'Automatisch Trace',
      description:
        'Automatisch trace berekent de snelste ondergrondse route voor middenspanningsnetwerken in Nederland, rekening houdend met actuele omgevingsdata.',
    },
    {
      icon: 'fas fa-solid fa-earth-europe',
      title: 'Portalen',
      description:
        'Portalen bieden alle projectgegevens op één platform, voor efficiënte communicatie, samenwerking en real-time updates gedurende het gehele project.',
    },
    {
      icon: 'fas fa-regular fa-file',
      title: 'Rapportage',
      description:
        'Rapportages bieden inzicht in omgevingsaspecten per tracé, waardoor in de ontwerpfase keuzes gemaakt kunnen worden om impact te verminderen.',
    },
    {
      icon: 'fas fa-solid fa-bore-hole',
      title: 'Bodemonderzoek',
      description: (
        <>
          Momenteel integreren wij onze automatische tracé- en rapportagetool met{' '}
          <a href="https://qterra.nl/werkwijze/qterra-app/" target="_blank" rel="noopener noreferrer">
            Qterra
          </a>{' '}
          om direct de relevante bodemgegevens voor het projectgebied op te halen.
        </>
      ),
    },
    {
      icon: 'fas fa-solid fa-laptop',
      title: 'Proces Harmonisatie',
      description:
        'Er wordt samengewerkt met diverse partijen om het engineeringproces te harmoniseren. Wij bieden slimme tools aan die zorgen voor een consistente, uniforme werkwijze.',
    },
    {
      icon: 'fas fa-regular fa-file',
      title: 'Revisie',
      description:
        'Dankzij de procesharmonisatie wordt de oplevering versneld. De revisie kan direct digitaal worden ingemeten en naar de opdrachtgever worden gestuurd.',
    },
  ];

  return (
    <section className="page-section" id="services">
      <div className="container">
        <div className="text-center">
          <h2 className="section-heading">Diensten</h2>
        </div>
        <div className="row text-center">
          {services.slice(0, 3).map((service, index) => (
            <div key={index} className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className={`${service.icon} fa-stack-1x fa-inverse`}></i>
              </span>
              <h4 className="my-3">{service.title}</h4>
              <p className="text-muted">{service.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="container">
        <div className="row text-center">
          {services.slice(3).map((service, index) => (
            <div key={index + 3} className="col-md-4">
              <span className="fa-stack fa-4x">
                <i className="fas fa-circle fa-stack-2x text-primary"></i>
                <i className={`${service.icon} fa-stack-1x fa-inverse`}></i>
              </span>
              <h4 className="my-3">{service.title}</h4>
              <p className="text-muted">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
